import { render, staticRenderFns } from "./MealReminder.vue?vue&type=template&id=025b990a&scoped=true&"
import script from "./MealReminder.vue?vue&type=script&lang=js&"
export * from "./MealReminder.vue?vue&type=script&lang=js&"
import style0 from "./MealReminder.vue?vue&type=style&index=0&id=025b990a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025b990a",
  null
  
)

export default component.exports